import React from 'react';
import { Link } from 'react-router-dom';
import { HOME_ROUTE } from '../../../routes/constant';

const Logo = () => (
  <Link to={HOME_ROUTE} className="flex items-center shrink-0 group">
    <img 
      src="https://app.tap2cash.in/assets/logo.png" 
      alt="Tap2Cash" 
      className="w-auto h-10 transition-transform duration-300 md:h-14 group-hover:scale-105"
    />
  </Link>
);

export default Logo;